import { Error } from '../realty/model/Error';
import { EventEmitter } from 'eventemitter3';
import Debugger from './Debugger';
import {
  Unauthorized,
  InvalidCadastreKeySubmitted,
  ServiceUnavailableOrInternalServerError,
  GenericError
} from '../Events';

const HTTP_UNAUTHORIZED = 401;
const HTTP_BAD_REQUEST = 400;
const HTTP_INTERNAL_SERVER_ERROR = 500;
const HTTP_SERVICE_UNAVAILABLE = 503;

export class ErrorHandler extends EventEmitter {
  public handle(error: Error): void {
    Debugger.print('Handling error:');
    Debugger.print(error);
    if (error.returnCode === HTTP_UNAUTHORIZED) {
      this.emit(Unauthorized);
    } else if (error.returnCode === HTTP_BAD_REQUEST) {
      this.emit(InvalidCadastreKeySubmitted);
    } else if (error.returnCode === HTTP_INTERNAL_SERVER_ERROR || error.returnCode === HTTP_SERVICE_UNAVAILABLE) {
      this.emit(ServiceUnavailableOrInternalServerError);
    } else {
      this.emit(GenericError);
    }
  }
}

export default new ErrorHandler();



/** WEBPACK FOOTER **
 ** ./src/utility/ErrorHandler.ts
 **/